"use strict";

exports.__esModule = true;
exports.DeviceDataItemSubscription = DeviceDataItemSubscription;
var _react = _interopRequireDefault(require("react"));
var _RealtimeConnection = require("../../API/RealtimeConnection");
var _excluded = ["deviceUuid", "dataItem"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function DeviceDataItemSubscription(_ref) {
  var deviceUuid = _ref.deviceUuid,
    dataItem = _ref.dataItem,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_RealtimeConnection.RealtimeDataSubscription, _extends({
    params: ["connectdata", {
      entity: {
        device: deviceUuid,
        type: dataItem.type_ns ? dataItem.type_ns + ":" + dataItem.type : dataItem.type,
        name: dataItem.name
      }
    }],
    normalize: normalizeDataItemValue
  }, extra));
}
function normalizeDataItemValue(doc) {
  if (doc == null) {
    return null;
  }
  var plant = doc.plant,
    tenant = doc.tenant;
  return {
    plant: plant,
    tenant: tenant,
    timestamp: Date.parse(doc.timestamp),
    receivedAt: Date.parse(doc.received_at),
    value: doc.value
  };
}